// Copyright (c) 2016 Deere & Company

import dropdownPlaceholders from '../utils/dropdown-placeholders';
import {isNotEmpty} from '../../../claim/shared/services/claim-shared-helper';
import otherStatuses from '../utils/other-statuses';

const checkOtherStatusValidity = statusChangeRequest => otherStatuses.includes(statusChangeRequest.newStatus.key);

const checkLocationUnknownStatusValidity = statusChangeRequest => [
    statusChangeRequest.lastContactDetails.lastContactDate,
    statusChangeRequest.lastContactDetails.letterSentDate
].every(condition => condition);

const checkMachineSEossStatusValidity = statusChangeRequest => {

    const isDateValid = Number.isInteger(statusChangeRequest.damageEventDate);
    const stringsSet = [
        isNotEmpty(statusChangeRequest.damageDesc),
        isNotEmpty(statusChangeRequest.damageEventDesc)
    ].every(rule => rule);

    return stringsSet && isDateValid;

};

const checkRemoveLocationUnknownValidity = statusChangeRequest => {

    const stringsSet = [
        isNotEmpty(statusChangeRequest.comments)
    ].every(rule => rule);

    return stringsSet;

};
const checkStolenStatusValidity = statusChangeRequest => {

    const stringsSet = [
        statusChangeRequest.lawEnforcementDetails.agency.name,
        statusChangeRequest.lawEnforcementDetails.agency.city,
        statusChangeRequest.lawEnforcementDetails.agency.country.key,
        statusChangeRequest.lawEnforcementDetails.reportNumber
    ];

    const isDateValid = Number.isInteger(statusChangeRequest.lawEnforcementDetails.stolenDate);

    const isStringsSetValid = stringsSet.every(elem => !dropdownPlaceholders.includes(elem) && elem !== '');

    return isStringsSetValid && isDateValid;

};

const checkStolenStatusPinPlateValidity = statusChangeRequest => {

    const stringsSet = [
        statusChangeRequest.lawEnforcementDetails.agency.name,
        statusChangeRequest.lawEnforcementDetails.agency.city,
        statusChangeRequest.lawEnforcementDetails.reportNumber
    ];

    const isDateValid = Number.isInteger(statusChangeRequest.lawEnforcementDetails.stolenDate);

    const isStringsSetValid = stringsSet.every(elem => !dropdownPlaceholders.includes(elem) && elem !== '');

    return isStringsSetValid && isDateValid;

};

const statusTypeValidators = {
    DMGD: checkMachineSEossStatusValidity,
    EOOS: checkMachineSEossStatusValidity,
    LCUK: checkLocationUnknownStatusValidity,
    NEW: checkOtherStatusValidity,
    RMLN: checkRemoveLocationUnknownValidity,
    STL1: checkStolenStatusValidity,
    STLP: checkStolenStatusPinPlateValidity,
    STNR: checkOtherStatusValidity,
    USED: checkOtherStatusValidity
};

export const verifyRequiredFields = statusChangeRequest =>
    statusTypeValidators[statusChangeRequest.newStatus.key] ?
        statusTypeValidators[statusChangeRequest.newStatus.key](statusChangeRequest) :
        false;




// WEBPACK FOOTER //
// ./src/product/status-change-request/helpers/verify-required-fields.js